/**
 * @generated SignedSource<<14c05122439ba82fe8671acf78da4c86>>
 * @relayHash de89e852ff3db35aac942d9525fb999b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f0bf8a7e8a1289ba9ebe4945dc712c92a3504eb94455782f92239804db0692ac

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppSelectorQuery$variables = Record<PropertyKey, never>;
export type AppSelectorQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"AppSelector_userDataFragment" | "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment">;
    };
  };
  readonly notifications: {
    readonly " $fragmentSpreads": FragmentRefs<"StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment">;
  } | null;
};
export type AppSelectorQuery = {
  response: AppSelectorQuery$data;
  variables: AppSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v0/*: any*/),
                  "action": "THROW",
                  "path": "me.user.accountId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "AppSelector_userDataFragment"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "me.user"
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "locale"
                  }
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f0bf8a7e8a1289ba9ebe4945dc712c92a3504eb94455782f92239804db0692ac",
    "metadata": {},
    "name": "AppSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "677d8755f796192524d92c2de849ffff";

export default node;
